<div class="row oona-container" *ngIf="!haveNoData">
  <div class="col-md-12" *ngFor="let post of data.data; let i = index">
    <oona-report-item [post]="post"
                      [pageOrderNo]="pageIndex"
                      [evenRow]="i % 2 === 0">
    </oona-report-item>
  </div>
  <div class="col-md-12">
    <div class="d-flex justify-content-end oona-report-pagination" *ngIf="!isExportingPdfReport">
      <achoo-pagination [minPage]="1" [maxPage]="maxPage" (pageChange)="onChangePage($event)"></achoo-pagination>
    </div>
  </div>
</div>
<div *ngIf="haveNoData" class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report.component.html